/**
 * Constants with the relevant 'election issues' to be displayed in the WhyVoteGreen section.
 * Somewhat deprecated, hasn't been used in recent elections, as we needed more flexibility.
 */

import Fed25Health from '../../assets/images/fe2025-1_health.png';
import Fed25Housing from '../../assets/images/fe2025-2_housing.png';
import Fed25Enviro from '../../assets/images/fe2025-3_enviro.png';
import Fed25Costs from '../../assets/images/fe2025-4_costs.png';
import Nsw23WVGCoal from '../../assets/images/nsw23_endcoal.png';
import Nsw23WVGPokies from '../../assets/images/nsw23_pokies.png';
import Nsw23WVGRent from '../../assets/images/nsw23_rents.png';
import Tas25Enviro from '../../assets/images/tas25-enviro.png';
import Tas25Health from '../../assets/images/tas25-health.png';
import Tas25Housing from '../../assets/images/tas25-housing.png';
import Tas25Stadium from '../../assets/images/tas25-stadium.png';

import Sa26Housing from "../../assets/images/sa26/sa26-housing.png"
import SA26LearnMore from "../../assets/images/sa26/sa26-learnmore.png"
import SA26ActionCOL from "../../assets/images/sa26/sa26-actioncol.png"
import SA26Environ from "../../assets/images/sa26/sa26-protectenviron.png"
import SA26AltEnviron from "../../assets/images/sa26/sa26-heyenviron.png"
import SA26AltTrain from "../../assets/images/sa26/sa26-trainhills.png"
import SA26AltPeople from "../../assets/images/sa26/sa26-peopleprofit.png"
import SA26AltGenevieve from "../../assets/images/sa26/sa26-genevieve.png"

const nsw23 = [
  {
    alt: 'End coal & gas by 2030',
    image: Nsw23WVGCoal,
    url: 'https://greens.org.au/nsw/climatechange2023',
  },
  {
    alt: 'Freeze & control rents, & ban unfair evictions',
    image: Nsw23WVGRent,
    url: 'https://greens.org.au/nsw/makehousingaffordable2023',
  },
  {
    alt: 'Pull the pin on pokies',
    image: Nsw23WVGPokies,
    url: 'https://greens.org.au/sites/default/files/2022-12/INITIATIVE_PULL_THE_PIN_ON_POKIES-1.pdf',
  },
];

const fed25 = [
  {
    alt: 'Dental into Medicare, See the GP for Free',
    image: Fed25Health,
    url: 'https://greens.org.au/health',
  },
  {
    alt: 'Fighting for Renters &amp; First Home Buyers',
    image: Fed25Housing,
    url: 'https://greens.org.au/housing',
  },
  {
    alt: 'Strong Climate &amp; Environment Action',
    image: Fed25Enviro,
    url: 'https://greens.org.au/climate',
  },
  {
    alt: 'Tackle the Cost of Living',
    image: Fed25Costs,
    url: 'https://greens.org.au/cost-of-living',
  },
];

const tas25 = [
  {
    alt: 'Protect our unique environment',
    image: Tas25Enviro,
    url: 'https://tasgreensmps.org/policy/',
  },
  {
    alt: 'Invest in health &amp; hospitals',
    image: Tas25Health,
    url: 'https://tasgreensmps.org/policy/',
  },
  {
    alt: 'Strong action on housing',
    image: Tas25Housing,
    url: 'https://tasgreensmps.org/policy/',
  },
  {
    alt: 'Stop the stadium',
    image: Tas25Stadium,
    url: 'https://tasgreensmps.org/policy/',
  },
];

const sa26 = [
  {
    alt: 'Housing for people, not for profit',
    image: Sa26Housing,
    url: 'https://greens.org.au/sa/election/',
  },
  {
    alt: 'Action on the cost of living',
    image: SA26ActionCOL,
    url: 'https://greens.org.au/sa/election/',
  },
  {
    alt: 'Protect our climate, and environment',
    image: SA26Environ,
    url: 'https://greens.org.au/sa/election/',
  },
  {
    alt: 'Learn more about what we&apos;re fighting for',
    image: SA26LearnMore,
    url: 'https://greens.org.au/sa/election-platform',
  },
];

const sa26alt = [
  {
    alt: 'Protecting our environment',
    image: SA26AltEnviron,
    url: 'https://greens.org.au/sa/policies/protecting-our-environment',
  },
  {
    alt: 'Train to the hills',
    image: SA26AltTrain,
    url: 'https://greens.org.au/sa/policies/cheap-and-accessible-public-transport',
  },
  {
    alt: 'Putting people before profits',
    image: SA26AltPeople,
    url: 'https://greens.org.au/sa/policies/planning-people-not-profit',
  },
  {
    alt: 'Learn more about Genevieve',
    image: SA26AltGenevieve,
    url: 'https://gen4heysen.com/',
  },
]

export default {
  // fed22,
  // vic22,
  nsw23,
  fed25,
  tas25,
  sa26,
  sa26alt
};
